import { render, staticRenderFns } from "./cd-chat-home.vue?vue&type=template&id=654a01f1"
import script from "./cd-chat-home.vue?vue&type=script&lang=js"
export * from "./cd-chat-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports